document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('[data-usipic-custom-page] #psd-container');
  if (!container) return;

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        var bg = container.querySelector('.custom-bg');
        if (bg) bg.style.transform = 'translateY(' + (window.scrollY * 0.3) + 'px)';
        ticking = false;
      });
      ticking = true;
    }
  });

  var productGroups = container.querySelectorAll('[class*="custom-group-"]');
  if (productGroups.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    productGroups.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });
  }

  var buttons = container.querySelectorAll('[class*="custom-explore"], [class*="custom-shop"]');
  buttons.forEach(function (el) {
    el.style.cursor = 'pointer';
    el.style.transition = 'transform 0.2s ease, opacity 0.2s ease';
    el.addEventListener('mouseenter', function () {
      el.style.transform = 'scale(1.05)';
      el.style.opacity = '0.85';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = 'scale(1)';
      el.style.opacity = '1';
    });
  });
});
